import React, {useState, Fragment} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import Friend from '../Friend/Friend'
import {setCurrentChat} from '../../../../store/actions/chat'
import Modal from '../../../Modal/Modal'
import ChatService from '../../../../services/chatService'
import './FriendList.scss'
import botImage from '../../../../assets/images/bot.png';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const FriendList = () => {

    const dispatch = useDispatch();
    const chats = useSelector(state => state.chatReducer.chats);
    const socket = useSelector(state => state.chatReducer.socket);

    const [showFriendsModal, setShowFriendsModal] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [groupName, setGroupName] = useState("");

    const openChat = (chat) => {
        console.log("OPEN CHAT: ", chat);
        if(chat.type === 'bot'){
            setIsBotChat('botChatActive');
        }
        else{
            setIsBotChat(null);
        }
        dispatch(setCurrentChat(chat))
    };

    const searchFriends = (e) => {
        ChatService.searchUsers(e.target.value)
            .then(res => setSuggestions(res))
    };

    const addNewFriend = (id, groupName) => {
        ChatService.createChat(id, groupName)
            .then(chats => {
                socket.emit('add-friend', chats);
                setGroupName("");
                setShowFriendsModal(false);
            }).catch(err => console.log(err))
    };
    const [isBotChat, setIsBotChat] = useState(null);
      // Add a special button for the IOP-Bot
    const startBotChat = () => {
        // Check if the bot chat already exists
        // const botChat = chats.find(chat => chat.tyoe === 'bot');
        const botChat = chats.find(chat => 
            chat.Users && chat.Users.some(user => user.firstName === 'IOP-Bot')
        );
    
        // If bot chat already exists, open it
        if (botChat) {
            openChat(botChat);
        } else {
            // Create a new bot chat if not present
            const newBotChat = {
                id: '000000',
                chatName: 'IOP-Bot Chat',
                type: 'bot',
                Users: [
                    {
                        id: '000000',
                        firstName: 'IOP-Bot',
                        lastName: 'Bot',
                        avatar: 'http://127.0.0.1:3000/bot.svg'
                    }
                ],
                Messages: [],
                isBot: true
            };
            
            openChat(newBotChat);
        }
    };
    

    return (
        <div id='friends' className='shadow-light'>
            <div id='title'>
                <h1 className='m-0'>Chats</h1>
                {/* <button onClick={() => setShowFriendsModal(true)}>Add</button> */}
                <button onClick={() => setShowFriendsModal(true)}>
                    <FontAwesomeIcon icon={['fas', 'user-plus']} style={{ marginRight: '2px' }} />
                    Add
                </button>
            </div>

            <hr/>

            <div id='friends-box'>
                {/* <div className={`bot-chat-button ${isBotChat}`} onClick={startBotChat}>
                    <h4>🤖 Talk to IOP-Bot </h4>
                </div> */}
                <div className={`bot-chat-button ${isBotChat}`} onClick={startBotChat}>
                    <img src={botImage} alt="Bot Icon" className="bot-icon" />
                    <h4>Talk to IOP-Bot</h4>
                </div>
                {
                    chats.length > 0
                        ? chats.map(chat => {
                            // Exclude the bot from the regular friend list if already added separately
                            // const isBotChat = chat.Users.some(user => user.firstName === 'IOP-Bot');
                            const isBotChat = chat.type === 'bot';
                            if (isBotChat) return null;

                            return <Friend click={() => openChat(chat)} chat={chat} key={chat.id}/>
                        })
                        : <p id='no-chat'>No friends added</p>
                }
            </div>

            {
                showFriendsModal &&
                <Modal click={() => setShowFriendsModal(false)}>
                    <Fragment key='header'>
                        <h3 className='m-0'>Create New Chat / Group</h3>
                    </Fragment>

                    <Fragment key='body'>
                        <p className='mb-1'>Group Name (Optional)</p>
                        <input onChange={e => setGroupName(e.target.value)} value={groupName} type='text'
                               placeholder='Group name'/>
                        <p className='mb-1'>Find Friends by Name</p>
                        <input onInput={e => searchFriends(e)} type='text' placeholder='Search...'/>
                        <div id='suggestions'>
                            {
                                suggestions.map(user => {
                                    return <div key={user.id} className='suggestion'>
                                        <p className='m-0'>{user.firstName} {user.lastName}</p>
                                        <button onClick={() => addNewFriend(user.id, groupName)}>Add</button>
                                    </div>
                                })
                            }
                        </div>
                    </Fragment>
                </Modal>
            }
        </div>
    )
};

export default FriendList